module.exports = __webpack_public_path__ + "img/currency.02343aed.svg";